<template>
  <div>
    <v-row>
      <v-col cols="4">
        <input-documento  @change="clearEstadoCivil" :cnpj="habilitaDoc" :label="docNomeRazao.doc" v-model="model.Cliente.DocumentoFederal" required :disabled="habilitaDados" />
      </v-col>
      <v-col cols="8">
        <input-text :label="docNomeRazao.nomeRazao" v-model="model.Cliente.Nome" required :disabled="habilitaDados" />
      </v-col>
      <v-col cols="4" v-if="$api.UI.Format.SomenteAlfanumerico(model.Cliente.DocumentoFederal).length === 11">
        <input-select :options="$aux.EstadoCivil" required label="Estado Civil" @change="$api.Multiplo.ClearConjuge(model.Cliente.PF)" v-model="model.Cliente.PF.EstadoCivil" />
      </v-col>
    </v-row>
    <v-row class="pl-4">
      <span class="subtitle-1">Informações de Contato</span>
    </v-row>
    <v-row>
      <v-col cols="5">
        <input-email v-model="model.Cliente.PessoaDadosContato.Email" required label="E-mail"/>
      </v-col>
      <v-col cols="3.5">
        <input-phone  v-model="model.Cliente.PessoaDadosContato.TelefoneCelular1" required label="Celular" cel/>
      </v-col>
      <v-col cols="3.5">
        <input-phone v-model="model.Cliente.PessoaDadosContato.TelefoneFixo1" label="Telefone Fixo" tel/>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <DadosEndereco v-model="model.Cliente.PessoaEndereco" title="Informações de Endereço"/>
      </v-col>
    </v-row>

      <v-row v-if="model.Cliente.PF.EstadoCivil === $aux.EstadoCivilEnum.Casado">
      <v-col cols="12">
        <span class="text-subtitle-2">Dados do Cônjuge</span>
        <v-divider/>
      </v-col>

      <v-col cols="4">
        <input-documento required cpf label="CPF" v-model="model.Cliente.PF.CPFConjuge" :rules="() => $api.Proposta.ValidacaoConjuge(model.Cliente.DocumentoFederal, model.Cliente.PF.CPFConjuge)"/>
      </v-col>
      <v-col cols="8">
        <input-text required label="Nome" v-model="model.Cliente.PF.NomeConjuge"/>
      </v-col>

      <v-col cols="5">
        <input-email required label="E-mail" v-model="model.Cliente.PF.EmailConjuge"/>
      </v-col>
      <v-col cols="3.5">
        <input-phone cel required label="Celular" v-model="model.Cliente.PF.TelefoneCelularConjuge" />
      </v-col>
      <v-col cols="3.5">
        <v-checkbox
          v-model="model.Cliente.PF.MostrarConjugeCCB" label="Mostrar na CCB?">
        </v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: null
  },
  data () {
    return { }
  },
  watch: {
    'model.DocumentoFederal' (val) {
      if (val) {
        this.clearEstadoCivil(val)
      }
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        return this.value
      }
    },
    habilitaDados () {
      return !!this.$route.query.codigoProposta
    },
    habilitaDoc () {
      var PF = this.$param.EST_PRODUTOS.map((p) => p.TipoPessoa).includes(('PF'))
      var PJ = this.$param.EST_PRODUTOS.map((p) => p.TipoPessoa).includes(('PJ'))
      if (PF) { return false } else if (PJ) { return true } else { return false }
    },
    docNomeRazao () {
      var PF = this.$param.EST_PRODUTOS.map((p) => p.TipoPessoa).includes(('PF'))
      var PJ = this.$param.EST_PRODUTOS.map((p) => p.TipoPessoa).includes(('PJ'))
      var doc = ''
      var nomeRazao = ''
      if (PF && PJ) {
        doc = 'CNPJ/CPF'
        nomeRazao = 'Nome/Razão Social'
        return { doc, nomeRazao }
      } else if (PF) {
        doc = 'CPF'
        nomeRazao = 'Nome'
        return { doc, nomeRazao }
      } else {
        doc = 'CNPJ'
        nomeRazao = 'Razão Social'
        return { doc, nomeRazao }
      }
    }
  },
  methods: {
    clearEstadoCivil () {
      const th = this
      th.carregaDados(th.model.Cliente.DocumentoFederal)
      th.$api.Multiplo.ClearConjuge(th.model.Cliente.PF)
      th.$set(th.model.Cliente.PF, 'EstadoCivil', null)
    },
    submit (callback) {
      const th = this
      const dtoPessoa = {
        dto: {
          Nome: th.model.Cliente.Nome,
          DocumentoFederal: th.model.Cliente.DocumentoFederal,
          PessoaDadosContato: th.model.Cliente.PessoaDadosContato,
          PF: th.model.Cliente.PF.EstadoCivil === th.$aux.EstadoCivilEnum.Casado ? th.model.Cliente.PF : { EstadoCivil: th.model.Cliente.PF.EstadoCivil }
        }
      }

      th.$api.Multiplo.CreateUpdatePessoa(dtoPessoa).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          const dtoEndereco = {
            dto: th.model.Cliente.PessoaEndereco,
            param: { DocumentoCliente: th.model.Cliente.DocumentoFederal }
          }
          th.$set(th.model.Cliente, 'TipoPessoa', th.$api.UI.Format.SomenteAlfanumerico(th.model.Cliente.DocumentoFederal).length === 11 ? 1 : 2)
          th.$api.Multiplo.CreateUpdatePessoaEndereco(dtoEndereco).then(function (response) {
            if (th.$api.UI.PostLoadData(response, true)) {
              callback()
            }
          })
        }
      })
    },
    async carregaDados (documento) {
      const th = this
      const obj = await th.$api.Multiplo.CarregaDadosPessoa(documento)
      if (obj) {
        th.$set(th.model.Cliente, 'Nome', obj.Nome);
        if (th.model.Cliente.PF) th.$set(th.model.Cliente.PF, 'EstadoCivil', obj.PF.EstadoCivil);
        if (obj.PessoaDadosContato) {
          th.$api.UTIL.Functions.SetAllButNull(th, th.model.Cliente, 'PessoaDadosContato', obj.PessoaDadosContato)
          th.$set(th.model.Cliente.PessoaDadosContato, 'TelefoneCelular1', th.$api.UI.Format.Celular(obj.PessoaDadosContato.TelefoneCelular1))
          th.$set(th.model.Cliente.PessoaDadosContato, 'TelefoneFixo1', obj.PessoaDadosContato.TelefoneFixo1 ? th.$api.UI.Format.Telefone(obj.PessoaDadosContato.TelefoneFixo1) : '')
        }
        if (obj.PessoaDadosEndereco) {
          th.$api.UTIL.Functions.SetAllButNull(th, th.model.Cliente, 'PessoaEndereco', obj.PessoaDadosEndereco)
        }
        if (obj.PF && obj.PF.EstadoCivil === th.$aux.EstadoCivilEnum.Casado) {
          th.$set(th.model.Cliente.PF, 'CPFConjuge', obj.PF.CPFConjuge)
          th.$set(th.model.Cliente.PF, 'NomeConjuge', obj.PF.NomeConjuge)
          th.$set(th.model.Cliente.PF, 'TelefoneCelularConjuge', obj.PF.TelefoneCelularConjuge)
          th.$set(th.model.Cliente.PF, 'EmailConjuge', obj.PF.EmailConjuge)
          th.$set(th.model.Cliente.PF, 'MostrarConjugeCCB', obj.PF.MostrarConjugeCCB)
        }
      } else {
        th.$set(th.model, 'Cliente', {
          Nome: null,
          PF: {},
          PessoaDadosContato: {},
          PessoaEndereco: {},
          PessoaBanco: {},
          DocumentoFederal: documento,
        })
      }
    }
  },
}
</script>
